// TODO: consolodate this file with the same util inside gatsby-node, will require setting up esm
import slugify from "slugify"

const removeJointWords = (txt: string) => {
  const jointWordsArr = ["on", "with", "and", "in"]
  const expStr = jointWordsArr.join("|")
  return txt
    .replace(new RegExp("\\b(" + expStr + ")\\b", "gi"), " ")
    .replace(/\s{2,}/g, " ")
    .replace(/ & /g, " ")
}

export const slug = (text: string) =>
  slugify(removeJointWords(text), { lower: true })
